<template>
    <common-content-spacer class="custom-reminder" height="small">
        <common-buttons align="right">
            <common-icon name="info" size="huge" @click="toogleIsCustomReminderInfoModalOpen()"></common-icon>
            <common-button
                v-if="!isCreatingReminder"
                type="primary"
                size="tiny-micro"
                :isSubmittable="false"
                :label="$t('pages.company.custom_reminders.create_reminder')"
                @click="openCreatingReminder()"
            ></common-button>
            <common-button
                v-if="isCreatingReminder"
                type="primary"
                size="tiny-micro"
                :isSubmittable="false"
                :label="$t('common.microcopy.back')"
                @click="closeCreatingReminder()"
            ></common-button>
        </common-buttons>

        <common-content-wrapper v-if="isCreatingReminder" width="medium">
            <common-content-spacer height="medium">
                <common-page-header :content="$t('pages.company.custom_reminders.title')" :isCenter="true"></common-page-header>
                <add-custom-reminder-form
                    :company="company"
                    :offers="offers"
                    :prefill="selectedCustomReminder"
                    :showPriceRSD="showPriceRSD"
                    @custom-reminder-changed="customReminderChanged($event)"
                ></add-custom-reminder-form>
            </common-content-spacer>
        </common-content-wrapper>
        <div v-if="customReminders?.length && !isCreatingReminder">
            <common-content-spacer height="medium">
                <common-table>
                    <thead>
                        <tr>
                            <th>{{ $t('pages.company.custom_reminders.row_title') }}</th>
                            <th>{{ $t('pages.company.custom_reminders.message') }}</th>
                            <th>{{ $t('pages.company.custom_reminders.show_reservation_time') }}</th>
                            <th>{{ $t('pages.company.custom_reminders.send_before') }}</th>
                            <th>{{ $t('pages.company.custom_reminders.type') }}</th>
                            <th>{{ $t('pages.company.custom_reminders.services') }}</th>
                            <th>{{ $t('pages.company.custom_reminders.active') }}</th>
                            <th>{{ $t('pages.company.custom_reminders.usage') }}</th>
                            <th>{{ $t('pages.company.custom_reminders.action') }}</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-for="customReminder in customReminders" :key="customReminder.id">
                            <td :data-label="$t('pages.company.custom_reminders.row_title')">
                                {{ customReminder.reminderName }}
                            </td>
                            <td :data-label="$t('pages.company.custom_reminders.message')">
                                {{ truncatedMessage(customReminder.reminderMessage) }}
                            </td>
                            <td :data-label="$t('pages.company.custom_reminders.show_reservation_time')">
                                <common-icon
                                    class="custom-reminder--reminder-time"
                                    :name="customReminder?.includeCalendarEventInfo ? 'checkbox-on' : 'checkbox-off'"
                                    size="large"
                                ></common-icon>
                            </td>
                            <td :data-label="$t('pages.company.custom_reminders.send_before')">
                                {{ customReminderLengtLabel(customReminder.remindBeforeMinutes) }}
                            </td>
                            <td :data-label="$t('pages.company.custom_reminders.type')">
                                {{ customReminderTypeLabel(customReminder.type) }}
                            </td>
                            <td :data-label="$t('pages.company.custom_reminders.services')">
                                <span v-for="offerId in customReminder.offerIds" :key="offerId">
                                    {{ getOfferName(offerId) }}
                                    <br />
                                </span>
                            </td>
                            <td :data-label="$t('pages.company.custom_reminders.active')">
                                <common-icon
                                    class="custom-reminder--reminder-time"
                                    :name="customReminder?.active ? 'checkbox-on' : 'checkbox-off'"
                                    size="large"
                                ></common-icon>
                            </td>
                            <td :data-label="$t('pages.company.custom_reminders.usage')">
                                <common-icon
                                    class="custom-reminder--delete"
                                    name="coins"
                                    size="medium"
                                    @click="checkReminderUsage(customReminder)"
                                ></common-icon>
                            </td>
                            <td :data-label="$t('pages.company.custom_reminders.action')">
                                <common-icon
                                    class="custom-reminder--edit"
                                    name="reservation"
                                    size="huge"
                                    @click="editCustomReminder(customReminder)"
                                ></common-icon>
                                <common-icon
                                    class="custom-reminder--delete"
                                    name="trash"
                                    size="huge"
                                    @click="openDeleteModal(customReminder.id)"
                                ></common-icon>
                            </td>
                        </tr>
                    </tbody>
                </common-table>
            </common-content-spacer>
        </div>
        <div v-else-if="!isCreatingReminder">
            <common-content-spacer :isCenter="true" height="medium">
                <p>{{ $t('pages.company.my_company.no_added_reminders') }}</p>
            </common-content-spacer>
        </div>
        <custom-reminder-usage-modal
            v-if="isUsageModalOpen"
            :customReminder="usageSelectedCustomReminder"
            :usageStatistic="usageStatisticCustomReminder"
            :statisticCurrency="statisticCurrency"
            :showPriceRSD="showPriceRSD"
            @close="closeUsageModal()"
        ></custom-reminder-usage-modal>
        <custom-reminder-info-modal
            v-if="isCustomReminderModalModalOpen"
            :showPriceRSD="showPriceRSD"
            @close="toogleIsCustomReminderInfoModalOpen()"
        ></custom-reminder-info-modal>
        <common-yes-no-modal
            v-if="isDeleteModalOpen"
            :showWarningIcon="true"
            height="tiny"
            :headingText="$t('modals.delete_offer.title')"
            :noButtonText="$t('common.microcopy.false')"
            :yesButtonText="$t('common.microcopy.true')"
            @close="isDeleteModalOpen = false"
            @continue="deleteCustomReminder()"
        ></common-yes-no-modal>
    </common-content-spacer>
</template>

<script>
    import CustomReminderInfoModal from 'components/modals/company/CustomReminderInfoModal'
    import AddCustomReminderForm from 'components/forms/company/AddCustomReminderForm'
    import CustomReminderUsageModal from 'components/modals/company/CustomReminderUsageModal'
    import CompanyAPI from 'api/CompanyAPI'
    import CustomReminderTypeEnum from 'enums/custom_reminder_type.enum'
    import CustomReminderLengthEnum from 'enums/custom_reminder_length.enum'
    import dayjs from 'dayjs'
    import CurrencyEnum from 'enums/currency.enum'

    export default {
        components: { AddCustomReminderForm, CustomReminderInfoModal, CustomReminderUsageModal },

        props: {
            customReminders: { type: Array, required: true },
            company: { type: Object, required: true },
            offers: { type: Array, required: true },
            showPriceRSD: { type: Boolean, default: true },
        },

        data: () => ({
            isCustomReminderModalModalOpen: false,
            isCreatingReminder: false,
            isDeleteModalOpen: false,
            selecetedDeleteId: undefined,
            selectedCustomReminder: {},
            payload: {},
            usageSelectedCustomReminder: {},
            usageStatisticCustomReminder: {},
            isUsageModalOpen: false,
            statisticCurrency: CurrencyEnum.RSD,
        }),

        methods: {
            openCreatingReminder() {
                this.isCreatingReminder = true
                this.unselectSelectedCustomRemidner()
            },

            unselectSelectedCustomRemidner() {
                this.selectedCustomReminder = {}
            },

            closeCreatingReminder() {
                this.isCreatingReminder = false
                this.unselectSelectedCustomRemidner()
            },
            toogleIsCustomReminderInfoModalOpen() {
                this.isCustomReminderModalModalOpen = !this.isCustomReminderModalModalOpen
            },

            customReminderChanged(event) {
                this.emitEvent({ name: 'custom-reminder-changed', payload: event })
                this.isCreatingReminder = false
                this.unselectSelectedCustomRemidner()
            },

            truncatedMessage(message) {
                return message.length > 35 ? message.substring(0, 35) + '...' : message
            },

            getOfferName(offerId) {
                const offer = this.offers?.find((offer) => offer.id === offerId)
                return offer.titleTextContent.originalText
            },
            openDeleteModal(id) {
                this.selecetedDeleteId = id
                this.isDeleteModalOpen = true
            },
            deleteCustomReminder() {
                this.isLoading = true
                CompanyAPI.deleteCustomReminders(this.company.id, this.selecetedDeleteId)
                    .then(() => {
                        this.discountId = undefined
                        this.isDeleteModalOpen = false
                        this.$toast.success(this.$t('common.microcopy.success'))
                        this.emitEvent({ name: 'custom-reminder-changed' })
                    })
                    .catch(() => {
                        this.$toast.error(this.$t('common.errors.common_error'))
                    })
            },

            editCustomReminder(customReminder) {
                this.selectedCustomReminder = customReminder
                this.isCreatingReminder = true
            },
            customReminderTypeLabel(type) {
                return CustomReminderTypeEnum[type].label
            },
            customReminderLengtLabel(minutes) {
                const reminder = CustomReminderLengthEnum[this.$i18n.locale].find((item) => Number(item.value) === minutes)
                return reminder.label
            },
            checkReminderUsage(customReminder) {
                this.payload.dateFrom = dayjs().startOf('month').format('YYYY-MM-DD')
                this.payload.dateTo = dayjs().endOf('month').format('YYYY-MM-DD')
                this.payload.customReminderId = customReminder.id
                this.payload.currency = this.showPriceRSD ? CurrencyEnum.RSD : CurrencyEnum.BAM
                CompanyAPI.getCustomReminderStatistic(this.company.id, this.payload)
                    .then(async (res) => {
                        this.usageSelectedCustomReminder = customReminder
                        this.usageStatisticCustomReminder = res
                        this.statisticCurrency = this.payload.currency
                        this.openUsageModal()
                    })
                    .catch(() => {
                        this.$toast.error(this.$t('common.errors.common_error'))
                    })
            },

            openUsageModal() {
                this.isUsageModalOpen = true
            },

            closeUsageModal() {
                this.isUsageModalOpen = false
                this.usageSelectedCustomReminder = {}
                this.usageStatisticCustomReminder = {}
            },
        },
    }
</script>

<style scoped lang="scss">
    @import 'styles/setup/_variables.scss';
    @import 'styles/setup/_mixins.scss';

    .custom-reminder {
        &--reminder-time {
            color: $color--accent-1;
        }

        &--delete {
            cursor: pointer;
            color: $color-bright-red;
        }

        &--edit {
            cursor: pointer;
            color: $color--accent-1;
        }
        @include breakpoint(smartphone-large) {
            .buttons {
                flex-direction: row;
                justify-content: space-between;
            }
        }
    }
</style>
